import Vue from "vue"
import messages from "./messages"
import readerSettingsMessages from "./readerSettingsMessages"
import audiobookMessages from "./audiobookMessages"
import feedDiscoveryMessages from "./feedDiscoveryMessages"
import decorationMessages from "./decorationMessages"
import qrLoginMessages from "./qrLoginMessages"
import avatarCropMessages from "./avatarCropMessages"
import tiktokLiveMessages from "./tiktokLiveMessages"
import liveRoomMessages from "./liveRoomMessages"
import rechargeMessages from "./rechargeMessages"
import fanProfileMessages from "./fanProfileMessages"
import securityMessages from "./securityMessages"
import communityLegalMessages from "./communityLegalMessages"
import guildMessages from "./guildMessages"
import supportMessages from "./supportMessages"
import privacyMessages from "./privacyMessages"
import relationshipMessages from "./relationshipMessages"
import vietnameseMessages from "./vietnameseMessages"
import directMessageMessages from "./directMessageMessages"
import roleAccessMessages from "./roleAccessMessages"
import publishMessages from "./publishMessages"
import dynamicIslandMessages from "./dynamicIslandMessages"
import fanGroupMessages from "./fanGroupMessages"
import pwaMessages from "./pwaMessages"
import imageViewerMessages from "./imageViewerMessages"
import gameRechargeMessages from "./gameRechargeMessages"

Object.keys(readerSettingsMessages).forEach(language => {
  if (messages[language]) messages[language].readerSettings = readerSettingsMessages[language]
})
Object.keys(audiobookMessages).forEach(language => {
  if (messages[language]) messages[language].audiobookUi = audiobookMessages[language]
})
Object.keys(feedDiscoveryMessages).forEach(language => {
  if (messages[language]) messages[language].feedDiscovery = feedDiscoveryMessages[language]
})

Object.keys(decorationMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].decoration = decorationMessages[language].decoration
  messages[language].discoverUi = messages[language].discoverUi || {}
  messages[language].discoverUi.decoration = decorationMessages[language].decoration.channel
  messages[language].errors = messages[language].errors || {}
  messages[language].errors["DECORATION.INVALID_TYPE"] = decorationMessages[language].decorationErrors.invalidType
  messages[language].errors["DECORATION.INVALID_SORT"] = decorationMessages[language].decorationErrors.invalidSort
  messages[language].errors["DECORATION.NOT_FOUND"] = decorationMessages[language].decorationErrors.notFound
  messages[language].errors["DECORATION.ALREADY_OWNED"] = decorationMessages[language].decorationErrors.alreadyOwned
  messages[language].errors["DECORATION.NOT_OWNED"] = decorationMessages[language].decorationErrors.notOwned
  messages[language].errors["DECORATION.PURCHASED"] = decorationMessages[language].decorationErrors.purchased
  messages[language].errors["DECORATION.EQUIPPED"] = decorationMessages[language].decorationErrors.equipped
})

Object.keys(qrLoginMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].qrLogin = qrLoginMessages[language].qrLogin
  messages[language].errors = Object.assign(messages[language].errors || {}, qrLoginMessages[language].errors)
})

Object.keys(avatarCropMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].avatarCrop = avatarCropMessages[language]
  messages[language].centerDetail.approvedAvatars = avatarCropMessages[language].presetsTip
})

Object.keys(tiktokLiveMessages).forEach(language => {
  if (!messages[language]) return
  Object.assign(messages[language].studioUi, tiktokLiveMessages[language].studioUi)
  Object.assign(messages[language].studioManager, tiktokLiveMessages[language].studioManager)
  Object.assign(messages[language].errors, tiktokLiveMessages[language].errors)
})

Object.keys(liveRoomMessages).forEach(language => {
  if (messages[language]) messages[language].liveRoom = liveRoomMessages[language]
})

Object.keys(rechargeMessages).forEach(language => {
  if (!messages[language]) return
  Object.assign(messages[language].centerDetail, rechargeMessages[language].centerDetail)
  messages[language].paymentResult = rechargeMessages[language].paymentResult
  Object.assign(messages[language].errors, rechargeMessages[language].errors)
})

Object.keys(fanProfileMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].fanProfile = fanProfileMessages[language].fanProfile
  Object.assign(messages[language].errors, fanProfileMessages[language].errors)
})

Object.keys(securityMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].securityUi = securityMessages[language].securityUi
  Object.assign(messages[language].errors, securityMessages[language].securityErrors)
  Object.assign(messages[language].notificationEvent, securityMessages[language].notificationEvents)
})

Object.keys(communityLegalMessages).forEach(language => {
  if (!messages[language]) return
  Object.assign(messages[language].settingsUi, communityLegalMessages[language])
})

Object.keys(guildMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].guildUi = guildMessages[language]
  Object.assign(messages[language].errors, guildMessages[language].errors)
})

// 越南语使用完整的聚合静态包，避免任一子模块缺失时回退成中文。
messages["vi-VN"] = vietnameseMessages
Object.assign(messages["vi-VN"].centerDetail, rechargeMessages["vi-VN"].centerDetail)
messages["vi-VN"].paymentResult = rechargeMessages["vi-VN"].paymentResult
Object.assign(messages["vi-VN"].errors, rechargeMessages["vi-VN"].errors)

Object.keys(pwaMessages).forEach(language => {
  if (messages[language]) messages[language].pwa = pwaMessages[language]
})

Object.keys(imageViewerMessages).forEach(language => {
  if (messages[language]) messages[language].imageViewer = imageViewerMessages[language]
})

Object.keys(gameRechargeMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].gameRecharge = gameRechargeMessages[language]
  Object.assign(messages[language].errors, gameRechargeMessages[language].errors)
})

Object.keys(directMessageMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].directMessage = directMessageMessages[language].directMessage
  Object.assign(messages[language].errors, directMessageMessages[language].errors)
})

Object.keys(relationshipMessages).forEach(language => {
  if (!messages[language]) return
  Object.assign(messages[language].errors, relationshipMessages[language])
})

Object.keys(supportMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].supportUi = supportMessages[language].supportUi
  Object.assign(messages[language].errors, supportMessages[language].errors)
  Object.assign(messages[language].notificationEvent, supportMessages[language].notificationEvents)
})

Object.keys(privacyMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].privacyManagement = privacyMessages[language].privacyManagement
  Object.assign(messages[language].errors, privacyMessages[language].errors)
})

Object.keys(roleAccessMessages).forEach(language => {
  if (!messages[language]) return
  Object.assign(messages[language].settingsUi, roleAccessMessages[language].settingsUi)
  Object.assign(messages[language].centerUi, roleAccessMessages[language].centerUi)
  Object.assign(messages[language].studioUi, roleAccessMessages[language].studioUi)
})

Object.keys(publishMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].publishUi = publishMessages[language]
  messages[language].centerUi.streamerWorkspace = publishMessages[language].streamerWorkspace
  messages[language].errors = messages[language].errors || {}
  messages[language].errors["CONTENT.IMAGE_REQUIRED"] = publishMessages[language].imageRequired
})

Object.keys(dynamicIslandMessages).forEach(language => {
  if (messages[language]) messages[language].dynamicIsland = dynamicIslandMessages[language]
})

Object.keys(fanGroupMessages).forEach(language => {
  if (!messages[language]) return
  messages[language].fanGroup = fanGroupMessages[language].fanGroup
  Object.assign(messages[language].errors, fanGroupMessages[language].errors)
})

const LANGUAGE_KEY = "starlive_language"
const COUNTRY_KEY = "starlive_country"
const REGION_KEY = "starlive_region"
const TIMEZONE_KEY = "starlive_timezone"

export const localeState = Vue.observable({
  language: localStorage.getItem(LANGUAGE_KEY) || "zh-CN",
  country: localStorage.getItem(COUNTRY_KEY) || "CN",
  region: localStorage.getItem(REGION_KEY) || "",
  timezone: localStorage.getItem(TIMEZONE_KEY) || Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
})

export const localeOptions = [
  { code: "zh-CN", name: "简体中文", direction: "ltr" },
  { code: "en-US", name: "English", direction: "ltr" },
  { code: "vi-VN", name: "Tiếng Việt", direction: "ltr" },
  { code: "ar-SA", name: "العربية", direction: "rtl" }
]

export const countryOptions = [
  { code: "CN", name: "中国 / China" },
  { code: "US", name: "美国 / United States" },
  { code: "SA", name: "السعودية / Saudi Arabia" },
  { code: "SG", name: "新加坡 / Singapore" },
  { code: "JP", name: "日本 / Japan" },
  { code: "VN", name: "Việt Nam / Vietnam" }
]

function valueByPath(object, path) {
  if (!object) return undefined
  if (Object.prototype.hasOwnProperty.call(object, path)) return object[path]
  const dot = path.indexOf(".")
  return dot < 0 ? object[path] : valueByPath(object[path.slice(0, dot)], path.slice(dot + 1))
}

export function translate(key, params = {}) {
  const localeMessages = messages[localeState.language] || messages["zh-CN"]
  let value = valueByPath(localeMessages, key) || valueByPath(messages["zh-CN"], key) || key
  Object.keys(params).forEach(name => {
    value = String(value).replace(new RegExp(`\\{${name}\\}`, "g"), params[name])
  })
  return value
}

export function translateError(code) {
  return translate(`errors.${code || "COMMON.REQUEST_FAILED"}`)
}

export function applyDocumentLocale() {
  const option = localeOptions.find(item => item.code === localeState.language) || localeOptions[0]
  document.documentElement.lang = localeState.language
  document.documentElement.dir = option.direction
}

export function updateLocale(values) {
  localeState.language = values.language || localeState.language
  localeState.country = values.country || localeState.country
  localeState.region = values.region === undefined ? localeState.region : values.region
  localeState.timezone = values.timezone || localeState.timezone
  localStorage.setItem(LANGUAGE_KEY, localeState.language)
  localStorage.setItem(COUNTRY_KEY, localeState.country)
  localStorage.setItem(REGION_KEY, localeState.region)
  localStorage.setItem(TIMEZONE_KEY, localeState.timezone)
  applyDocumentLocale()
  window.dispatchEvent(new CustomEvent("locale-changed", { detail: { ...localeState } }))
}

export function requestLocaleHeaders() {
  return { "X-Language": localeState.language, "X-Country": localeState.country, "X-Region": localeState.region, "X-Timezone": localeState.timezone }
}

function utcDate(value) {
  if (!value) return null
  if (value instanceof Date) return value
  const text = String(value)
  return new Date(/[zZ]|[+-]\d\d:\d\d$/.test(text) ? text : `${text.replace(" ", "T")}Z`)
}

export default {
  install() {
    Vue.prototype.$locale = localeState
    Vue.prototype.$t = translate
    Vue.prototype.$n = (value, options = {}) => new Intl.NumberFormat(localeState.language, options).format(Number(value || 0))
    Vue.prototype.$compact = value => new Intl.NumberFormat(localeState.language, { notation: "compact", maximumFractionDigits: 1 }).format(Number(value || 0))
    Vue.prototype.$currency = (value, currency = "USD") => new Intl.NumberFormat(localeState.language, { style: "currency", currency }).format(Number(value || 0))
    Vue.prototype.$d = (value, options = {}) => {
      const date = utcDate(value)
      return date && !Number.isNaN(date.getTime()) ? new Intl.DateTimeFormat(localeState.language, { timeZone: localeState.timezone, ...options }).format(date) : ""
    }
  }
}

applyDocumentLocale()
